import { ViberIcon, VIBER_HREF } from '@/components/ui/ContactButtons'

/**
 * Fixed, site-wide chat bubble (mobile only) — replaces the WhatsApp+Viber
 * pill row that used to live in the hero. Mounted once in App.tsx, outside
 * <Routes>, so it persists across every page instead of just the home hero.
 * WhatsApp intentionally dropped here per the user's request — Viber only.
 *
 * `cookieBannerVisible` is passed down from App.tsx (same lifted state
 * CookieConsent uses) rather than read via its own hook instance, so both
 * components react to the exact same dismiss — otherwise this bubble could
 * stay shifted up after the banner's been dismissed, until reload. Shifts
 * from bottom-5 to bottom-24 while the banner (full-width, bottom-0) is on
 * screen, so the two don't overlap on a visitor's first mobile visit.
 */
export function ViberBubble({ cookieBannerVisible }: { cookieBannerVisible: boolean }) {
  return (
    <a
      href={VIBER_HREF}
      aria-label="Viber"
      className={`fixed right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-viber text-white
                 shadow-[0_4px_20px_rgba(115,96,242,0.5)] transition-all duration-normal hover:scale-110 active:scale-95 lg:hidden
                 ${cookieBannerVisible ? 'bottom-24' : 'bottom-5'}`}
    >
      <ViberIcon size={26} />
    </a>
  )
}
